import { PropsWithChildren } from 'react'
import { I18nProvider } from 'react-aria'

import { useSession } from '@/modules/access/hooks/useSession'

export default function ReactAriaI18nProvider(props: PropsWithChildren) {
  const { userSelectedLocale } = useSession()
  return <I18nProvider locale={userSelectedLocale}>{props.children}</I18nProvider>
}
